import { FormattedMessage } from 'react-intl';

import { messages } from '../messages';

export const AvatarGroupStack = () => {
	return (
		<FormattedMessage {...messages.avatarGroupLabel}>
			{(label) => (
				// eslint-disable-next-line no-restricted-syntax
				<img
					src={
						'https://wac-cdn.atlassian.com/dam/jcr:3187ccc5-05f8-4ab1-bb68-3aee84b38cfb/avatarGroup.svg?cdnVersion=1384'
					}
					height="26px"
					aria-label={label as unknown as string}
				/>
			)}
		</FormattedMessage>
	);
};
